import { render, staticRenderFns } from "./document-folder-tree.vue?vue&type=template&id=3976fa2f&scoped=true"
import script from "./document-folder-tree.vue?vue&type=script&lang=js"
export * from "./document-folder-tree.vue?vue&type=script&lang=js"
import style0 from "./document-folder-tree.vue?vue&type=style&index=0&id=3976fa2f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3976fa2f",
  null
  
)

export default component.exports